import { ReactNode } from 'react'

import { ImageContainer } from '@/components'
import { EquipmentVista as Vista } from '@/services/backend/config/entities'

interface Props {
  data: Vista
  children?: ReactNode
}

export const ViewVistaDisplayer = ({ data, children }: Props) => {
  return (
    <div className="flex items-center gap-2">
      <ImageContainer src={data.imageStr ?? undefined} className="size-16" />
      <p className="flex-1">{data.name}</p>
      {children}
    </div>
  )
}
